import {useState, useRef} from 'react';
import {getOptions, PurchaseOrderItemStatusType, PurchaseOrderStatusType} from "../../api/Constants";
import {Popover, Select, Tag} from 'antd';
import {updatePurchaseOrderLineState} from "../../api/Api";

export const PurchaseOrderItemStatusWidget = ({item, onApiFail, onRefresh, enableEdits=true, isFulfillment=false, props}) => {
    const status = item.state;
    const [active, setActive] = useState(false);
    const inputRef = useRef(null);

    let options;
    // Quick insecure implementation
    if (isFulfillment) {
        const labels = PurchaseOrderStatusType.Label;
        options = [
            {
                value: PurchaseOrderItemStatusType.Requested,
                label: labels[PurchaseOrderItemStatusType.Requested]
            },
            {
                value: PurchaseOrderItemStatusType.InProgress,
                label: labels[PurchaseOrderItemStatusType.InProgress]
            },
            {
                value: PurchaseOrderItemStatusType.Complete,
                label: labels[PurchaseOrderItemStatusType.Complete]
            }
        ]
    } else {
        options = getOptions(PurchaseOrderItemStatusType)();
    }

    const onSelect = (val) => {
        setActive(false);
        if (val === item.state) {
            return;
        }
        updatePurchaseOrderLineState(item.id, val).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const onBlur = () => {
        setActive(false);
    }

    const onClick = () => {
        setActive(true);
        setTimeout(() => {
            inputRef.current.focus();
        }, 20)
    }

    let tagColor = "#108ee9";
    let popOverContent;
    switch (status) {
        case PurchaseOrderItemStatusType.Requested:
            tagColor = "#108ee9";
            popOverContent = `Item is Newly Requested.  Set to In-Progress when work has begun`;
            break;
        case PurchaseOrderItemStatusType.InProgress:
            tagColor = "#f55442";
            popOverContent = `Work is in-progress.  Set to Complete when work is finished`
            break;
        case PurchaseOrderItemStatusType.Complete:
            tagColor = "#0ea133";
            popOverContent = `Work is Completed.  Set to Verified when item is verified in inventory`
            break;
        case PurchaseOrderItemStatusType.Verified:
            tagColor = "#8f8f8f";
            // tagColor = "#f5f50a";
            popOverContent = `Work is Verified.`
            break;
        default:
    }

    if (active && enableEdits === true) {
        return <div>
            <Popover content={popOverContent}>
                <Select ref={inputRef} value={item.state} options={options} onSelect={onSelect} onBlur={onBlur} popupMatchSelectWidth={false}/>
            </Popover>
        </div>
    } else {
        return <Popover content={popOverContent}>
            <div onClick={onClick} style={{cursor: 'pointer'}}>
                <Tag color={tagColor}>{PurchaseOrderItemStatusType.Label[status]}</Tag>
            </div>
        </Popover>
    }
}